import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { differenceInDays } from "date-fns";
import {
  //   getEmployeeListPersonsListed,
  setTheEmployeeRangetwo,
  setTheEmployeeRangeOne,
  setUserDeleteActions,
  setTheProfileSignatureActions,
  setClientBranchSearchAction,
  setGeoLoactionStateAction,
  setZoneActions,
  setRegionActions,
  SetTheDashboardClientList,
  settheEmployeeActionState,
  settheEmployeeActionRegion,

  settheEmployeeActionZone,
  setTheEmpoyeeAction_branch,
  setthe_requested_employee_list_filters,
  setTablePositionPersist,
  setthe_employeee_actions_forEmployee_filter
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import _ from "lodash";
import Delete from "../../AppComponent/Popup/Delete";
import Select from "react-select";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import useDebouncedEffect from 'use-debounced-effect';
import { Employee_edit } from "./Employee_edit";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import excelSheetImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-15.svg";
import Exportpopup from "../EmployeeProfile/Exportpopup";
import RequestedPopup from "../EmployeeProfile/RequestedPopup";
import { RehireCell, RejoinLinkButton, RejoinLinkPopup, useRejoinStatus } from "../ExitWorkflow/RejoinLink";


const EmployeeActions = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );

  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  // CR-2 rejoin link for Inactive rows and CR-3 Eligible for Rehire column (both only for exit HR).
  const rejoin = useRejoinStatus(state.ProfileSignatureCalls.ProfileSignatureDatas);
  const [rejoinEmployeeId, setRejoinEmployeeId] = useState(null);
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(today);

  var st = convert(state.EmployeeVerificationsNeed.EmployeeRangeOne);
  var et = convert(state.EmployeeVerificationsNeed.EmployeeRangeTwo);

  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed.EmployeeRangeOne == "" ? [] : [st, et]
  );
  const [dtpageindex, setdtPageindex] = useState(TablePositionPersist?.EmployeeActions?.page == undefined ? 1 : TablePositionPersist.EmployeeActions.page);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState(TablePositionPersist?.EmployeeActions?.search == "" || TablePositionPersist?.EmployeeActions?.search == undefined ? "" : TablePositionPersist.EmployeeActions.search);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [OldEmp, setOldEMp] = useState(state?.EmployeeVerificationsNeed?.Employee_actions_Employee_filter_old_new ? state?.EmployeeVerificationsNeed?.Employee_actions_Employee_filter_old_new : {
    label: "NEW EMPLOYEE",
    value: false,
  });
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [nameList4, setOptions4] = useState([]);

  const [datas, setData] = useState({
    // zone: state.EmployeeVerificationsNeed?.EmployeeActionZone?.value?.value || '',
    // state: state.EmployeeVerificationsNeed?.EmployeeActionsState?.value?.value || '',
    // region: state.EmployeeVerificationsNeed?.EmployeeActionRegion?.value?.value || ''
    state: state.EmployeeVerificationsNeed.EmployeeActionsState?.value,
    zone: state.EmployeeVerificationsNeed?.EmployeeActionZone?.value,

    region: state.EmployeeVerificationsNeed.EmployeeActionRegion?.value
  });

  const [records, setrecords] = useState(null)
  const [EditPopup, seteditpopup] = useState(false)
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch: ""
  };

  const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);
  const [exportpopup, setexportpopup] = useState(false)
  const [date_of_joining, setdate_of_joinging] = useState(null)

  const [nameList5, setOptions5] = useState([]);

  const [multiselect, setMuliselect] = useState(
    state.EmployeeVerificationsNeed.EmployeeActionsState

  );
  const [multiselect1, setMuliselect1] = useState(
    state.EmployeeVerificationsNeed.EmployeeActionRegion


  );
  const [multiselect3, setMuliselect3] = useState(
    state.EmployeeVerificationsNeed.EmployeeActionZone

  );
  const [searchBranch, setSearch] = useState("");
  const [Client, setClients] = useState(state.EmployeeVerificationsNeed.EmployeeAction_Branch ? state.EmployeeVerificationsNeed.EmployeeAction_Branch?.value : "");

  const oldemloyeeOptions = [
    {
      value: true,
      label: "EXISTING EMPLOYEE",
    },
    {
      value: false,
      label: "NEW EMPLOYEE",
    },
  ];
  const [oldemplo, setoldemp] = useState({ old_employee: state?.EmployeeVerificationsNeed?.Employee_actions_Employee_filter_old_new ? state?.EmployeeVerificationsNeed?.Employee_actions_Employee_filter_old_new?.value : false });

  const [employee_det, setemployee_det] = useState(null);
  const form_requested_lists = [

    {
      value: true,
      label: "EMP REQUESTS",
    },
  ];
  const [requested, setrequested] = useState(
    state?.EmployeeVerificationsNeed?.Requested_employee_list_filters ? state?.EmployeeVerificationsNeed?.Requested_employee_list_filters : {
      label: "",
      value: "",
    });
  const [requested_emp, setrequested_emp] = useState({ is_form_requested: state?.EmployeeVerificationsNeed?.Requested_employee_list_filters?.value ? state?.EmployeeVerificationsNeed?.Requested_employee_list_filters?.value : "" });
  const [requestedpopup, setrequestedpopup] = useState(false);

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheEmployeeRangeOne(range[0]));
      dispatch(setTheEmployeeRangetwo(range[1]));
    }
    else {
      dispatch(setTheEmployeeRangeOne(""));
      dispatch(setTheEmployeeRangetwo(""));

    }
  }, [range]);

  useEffect(() => {
    const payload = {
      search: searchBranch,
      page_size: 30,
      page: 1,
      data: datas,
      client: "",
      month: "",
      year: "",

    };
    dispatch(setClientBranchSearchAction(payload));

    //  console.log(state.ClientBranch.ClientBranchess, "asdasd");
  }, [searchBranch, datas]);
  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch: e

    })
  };

  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: datas.region,
    };
    dispatch(setZoneActions(payloads));
  }, [datas.region, SearchedVal.zoneSearch]);
  useEffect(() => {
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: datas.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
  }, [datas.state, SearchedVal.regionSearch]);

  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });

      // console.log(objectArray , "objectArray");
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, searchBranch]);




  useEffect(() => {
    // if (range.length > 0 && !range.includes("NaN-aN-aN")) {
    const payloads = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      // from_date: range[0],
      // to_date: range[1],
      // range: true,
      old_employee: oldemplo.old_employee,
      state: datas.state,
      region: datas.region,
      zone: datas.zone,
      client: Client,
      is_form_requested: requested_emp?.is_form_requested,


    };
    //   dispatch(getEmployeeListPersonsListed(payloads));
    dispatch(setTheProfileSignatureActions(payloads)); ///for listout the employeee
    // }

    dispatch(
      setTablePositionPersist({ data: payloads, pageName: "EmployeeActions" })
    );

  }, [search, dtpageindex, oldemplo, datas, Client, requested_emp]);
  console.log(requested_emp, "requested_emp");


  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    // console.log(value, "vlues");
    setdtPageindex(1);

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },

    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];


      },
      // appearance: "default",
      placement: "left",

    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },

  ];

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const isAdminEmails =
    (state.SideBarFiles.UserEmailID == "codoid@gmail.com" ||
      state.SideBarFiles.UserEmailID == "admin@uds.in" ||
      state.SideBarFiles.UserEmailID == "admin@gmail.com" ||
      state.SideBarFiles.UserEmailID == "adminit@uds.in");

  const columns = [
    {
      Header: "Tnx Id",
      accessor: "",
      Cell: (row) => {
        if (
          row.row.original.user_id.id != undefined &&
          row.row.original.user_id.id != null
        ) {
          const userId = row.row.original.user_id.id;
          const lastFourDigits = userId.slice(-6);
          return <p className="PTAGs">{lastFourDigits}</p>;
        }
      },
    },


    // oldemplo.old_employee && 
    {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            //    onClick={(e) => {
            //   handleEmployeeDetails(row.row.original);
            //}}
            >

              <div className="">
                <span>

                  {row.row.original.user_id.user_uid != null && row.row.original.user_id.user_uid != undefined &&
                    row.row.original.user_id.user_uid != ""
                    ?
                    row.row.original.user_id.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },

    {
      Header: "Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <p
              className="PTAGs"
              data-tooltip-id="my-tooltip"
              data-tooltip-content={`${formattedTime}`}
            >
              {`${row.row.original.created_at.slice(0, 10)
                }`}
            </p>
          </>
        );
      },
    },


    {
      Header: "Employee Name",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            <div
              className="UserName"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              style={{ position: 'relative' }} // Ensure the tooltip is positioned correctly

            >

              {row.row.original.user_id != null &&
                row.row.original.user_id != undefined && row.row.original.user_id != ""
                &&
                row.row.original.user_id.first_name != null && row.row.original.user_id.first_name != undefined
                &&
                row.row.original.user_id.first_name != "" ?
                <div className="">
                  <span

                  // data-tooltip-id="list-ToolTips"
                  // data-tooltip-content={row.row.original.user_id.first_name}
                  >
                    {/* Full name (first + last), no longer cut at 9 characters; the table scrolls horizontally. */}
                    {[row.row.original.user_id.first_name, row.row.original.user_id.last_name]
                      .filter((part) => part && String(part).trim())
                      .map((part) => capitalizeFirstLetter(String(part).trim()))
                      .join(" ")}
                  </span>
                </div>
                :

                <>--</>}

            </div>
          </>
        );
      },
    },


    {
      Header: "Mobile",
      accessor: "",
      Cell: (row) => {
        const mobile = row?.row?.original?.user_id?.phone_number;
        const isActive = row?.row?.original?.user_id?.is_active;

        return (
          <>
            {mobile ? (
              <div className="UserName MobileNumber">
                <span>{isAdminEmails ? mobile : isActive ? `******${String(mobile).slice(-4)}` : mobile}</span>
              </div>
            ) : (
              <div className="UserName MobileNumber">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "Aadhaar Number",
      accessor: "",
      Cell: (row) => {
        const aadhar = row?.row?.original?.aadhar_number;
        const isActive = row?.row?.original?.user_id?.is_active;

        return (
          <>
            {aadhar ? (
              <div className="UserName MobileNumber">
                <span>{isAdminEmails ? aadhar : isActive ? `**** **** ${String(aadhar).slice(-4)}` : aadhar}</span>
              </div>
            ) : (
              <div className="UserName MobileNumber">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      Header: "Pan Number",
      accessor: "",
      Cell: (row) => {
        const pan = row?.row?.original?.pan_number;
        const isActive = row?.row?.original?.user_id?.is_active;

        return (
          <>
            {pan ? (
              <div className="UserName MobileNumber">
                <span>{isAdminEmails ? pan : isActive ? `******${String(pan).slice(-4)}` : pan}</span>
              </div>
            ) : (
              <div className="UserName MobileNumber">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "Account Number",
      accessor: "",
      Cell: (row) => {
        const accountNumber = row?.row?.original?.account_number;
        const isActive = row?.row?.original?.user_id?.is_active;

        return (
          <>
            {accountNumber ? (
              <div className="UserName MobileNumber">
                <span>{isAdminEmails ? accountNumber : isActive ? `**** **** ${String(accountNumber).slice(-4)}` : accountNumber}</span>
              </div>
            ) : (
              <div className="UserName MobileNumber">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    //           {
    //             Header: "Zone",
    //             accessor: "",
    //             Cell: (row) => {
    //               return (
    //                 <>
    //                   {row.row.original.user_id != null &&
    //                   row.row.original.user_id.zone_id != null &&
    //                   row.row.original.user_id.zone_id != undefined ? (
    //                     <>
    //                       {row.row.original.user_id.zone_id != undefined  && row.row.original.user_id.zone_id.length > 0 ? (
    //                         <div className="UserName">
    //                           <span

    //                           >
    //                             {/* {row.row.original.user_id.zone_id.zone_name} */}

    //                             {row.row.original.user_id.zone_id.map((item) => {
    //                                console.log(item ,"203912309item",item.zone_name);

    //                               return <>{item.zone_name != "" && item.zone_name != null &&item.zone_name.length > 10 ?

    //   <p
    //   data-tooltip-id="list-ToolTips"
    //   data-tooltip-content={item.zone_name}
    //    className="MobileNumber"
    //   >{item.zone_name.slice(0,8)}</p>
    //   :

    //   <>
    //   {item.zone_name != null && item.zone_name !="" ? 
    //   <p                               data-tooltip-id="list-ToolTips"
    //    className="MobileNumber"
    //                                 data-tooltip-content={item.zone_name}>{item.zone_name}</p>
    //   : <>---</> }
    // </>


    //                               }</>;
    //                             }
    //                             )}
    //                           </span>
    //                         </div>
    //                       ) : (
    //                         <div className="UserName MobileNumber">
    //                           <span>---</span>
    //                         </div>
    //                       )}
    //                     </>
    //                   ) : (
    //                     <div className="UserName MobileNumber">
    //                       <span>{"----"}</span>
    //                     </div>
    //                   )}
    //                 </>
    //               );
    //             },
    //           },
    {
      Header: "Zone",
      accessor: "",
      Cell: (row) => {
        const [hoveredIndex, setHoveredIndex] = useState(null); // Keep track of which zone is being hovered over

        return (
          <>
            {row.row.original.user_id != null &&
              row.row.original.user_id.zone_id != null &&
              row.row.original.user_id.zone_id != undefined ? (
              <>
                {row.row.original.user_id.zone_id.length > 0 ? (
                  <div className="UserName">
                    <span className="PTAGs">
                      {row.row.original.user_id.zone_id.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            {item.zone_name.length > 10 ? (
                              <p
                                className="PTAGs"
                                onMouseEnter={() => setHoveredIndex(index)} // Set index on hover
                                onMouseLeave={() => setHoveredIndex(null)} // Remove hover index when not hovering
                                style={{ position: 'relative' }} // Ensure relative position for tooltip
                              >
                                {item.zone_name.slice(0, 8)}...
                                {hoveredIndex === index && (
                                  <div className="custom-tooltip">
                                    {item.zone_name}
                                  </div>
                                )}
                              </p>
                            ) : (
                              <p
                                className="PTAGs"
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                style={{ position: 'relative' }}
                              >
                                {item.zone_name}
                                {hoveredIndex === index && (
                                  <div className="custom-tooltip">
                                    {item.zone_name}
                                  </div>
                                )}
                              </p>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </span>
                  </div>
                ) : (
                  <div className="UserName PTAGs">
                    <span>---</span>
                  </div>
                )}
              </>
            ) : (
              <div className="UserName PTAGs">
                <span>{"----"}</span>
              </div>
            )}
          </>
        );
      },
    },

    // {
    //     Header: "Client",
    //     accessor: "",
    //     Cell: (row) => {
    //       return (
    //         <>
    //           {row.row.original.client_id != null &&
    //           row.row.original.client_id != undefined &&
    //           row.row.original.client_id.client_name !="" &&
    //           row.row.original.client_id.client_name != undefined ? (
    //             <div className="UserName MobileNumber">
    //               <span

    //               data-tooltip-id="list-ToolTips"
    //               data-tooltip-content={row.row.original.client_id.client_name}

    //               >{row.row.original.client_id.client_name.length > 16 ? 

    //             <>
    //             {row.row.original.client_id.client_name.slice(0,14)}..
    //             </>
    //             :
    //             <>{row.row.original.client_id.client_name}</>

    //             }</span>
    //             </div>
    //           ) : (
    //             <div className="UserName MobileNumber">
    //               <span>---</span>
    //             </div>
    //           )}
    //         </>
    //       );
    //     },
    //   },
    {
      Header: "Branch",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            {row.row.original.client_id != null &&
              row.row.original.client_id != undefined &&
              row.row.original.client_id.client_name != "" &&
              row.row.original.client_id.client_name != undefined ? (
              <div className="UserName"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                style={{ position: 'relative', width: "158px" }} // Relative positioning for tooltip placement
              >
                <span style={{ display: "flex" }} >
                  {row.row.original.client_id.client_name.length > 12 ? (
                    <>
                      {row.row.original.client_id.client_name.slice(0, 12)}...
                    </>
                  ) : (
                    <>{row.row.original.client_id.client_name}</>
                  )}
                </span>

                {/* Custom tooltip */}
                {showTooltip && (
                  <div className="custom-tooltip">
                    {row.row.original.client_id.client_name}
                  </div>
                )}
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    // oldemplo.old_employee && 
    {
      Header: "Status",
      accessor: "",
      Cell: (row) => {
        if (row.row.original.user_id !== undefined && row.row.original.user_id !== null) {
          const isActive = row.row.original.user_id.is_active;
          const buttonStyle = {
            // backgroundColor: isActive ? "#E2F4DD" : "#ff8a8ab8", // Light green for active, light red for inactive
            // // color: "white",
            color: isActive ? "green" : "red",
            // border: "none",
            // borderRadius: "5px",
            // // padding: "10px 15px",
            // padding: "0.375rem 0.75rem",
            // cursor: "pointer",
          };

          return (
            <p className="p-0 m-0" style={buttonStyle}>
              {isActive ? "Active" : "Inactive"}
            </p>
          );
        }
        return "--";
      },
    },
    rejoin.enabled && {
      id: "eligible_for_rehire",
      Header: "Eligible for Rehire",
      accessor: "",
      Cell: (row) => <RehireCell status={rejoin.statusMap[row.row.original.user_id?.id]} />,
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {

        const client_name = row.row.original.client_id?.client_name ? row.row.original.client_id?.client_name : ""
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteId(row.row.original.user_id.id);
                  setDeletePopup(true);
                }}
              >
                <span className="OuterActionSpan">
                  <span className="EditImages">
                    <img src={DeleteImages} />
                  </span>
                  <span className="ActionsList"> Delete </span>
                </span>
              </button>

              <RejoinLinkButton
                enabled={rejoin.enabled}
                status={rejoin.statusMap[row.row.original.user_id?.id]}
                inactive={row.row.original.user_id ? !row.row.original.user_id.is_active : false}
                onClick={() => setRejoinEmployeeId(row.row.original.user_id.id)}
              />

              {
                requested_emp?.is_form_requested == true ? (
                  <>
                    <button
                      className=" btn Status"
                      component="span"
                      onClick={(e) => {
                        e.stopPropagation();
                        console.log(row.row.original, "asdupaosd row.row.original");
                        setemployee_det(row.row.original)
                        setrecords(row.row.original?.user_id?.id);
                        setdate_of_joinging(row.row.original?.date_of_joining)
                        setrequestedpopup(true);
                      }}
                      disabled={
                        row.row.original.is_decline == false &&
                          row.row.original.is_pending == false &&
                          row.row.original?.create_employee == true &&
                          client_name != null && client_name != "" && client_name.toLowerCase().includes("sony") ? false : true}
                    >

                      <span className="OuterActionSpan">
                        <span className="EditImages">
                          <img src={excelSheetImage} />
                        </span>
                        <span className="ActionsList"> Exports </span>
                      </span>
                    </button>


                  </>) :
                  <>

                    {oldemplo.old_employee && (

                      <button
                        className=" btn Status"
                        component="span"
                        onClick={(e) => {
                          e.stopPropagation();
                          seteditpopup(true);
                          setrecords(row.row.original);
                        }}
                      >

                        <span className="OuterActionSpan">
                          <span className="EditImages">
                            <img src={EditImages} />
                          </span>
                          <span className="ActionsList"> Edit </span>
                        </span>
                      </button>
                    )}

                    <button
                      className=" btn Status"
                      component="span"
                      onClick={(e) => {
                        e.stopPropagation();
                        setrecords(row.row.original?.user_id?.id);
                        setdate_of_joinging(row.row.original?.date_of_joining)
                        setexportpopup(true)
                      }}
                      disabled={
                        row.row.original.is_decline == false &&
                          row.row.original.is_pending == false &&
                          row.row.original?.create_employee == true &&
                          client_name != null && client_name != "" && client_name.toLowerCase().includes("sony") ? false : true}
                    >

                      <span className="OuterActionSpan">
                        <span className="EditImages">
                          <img src={excelSheetImage} />
                        </span>
                        <span className="ActionsList"> Exports </span>
                      </span>
                    </button>


                  </>

              }

            </div>
          </>
        );
      },
    },
  ].filter(Boolean);
  //  console.log(oldemplo.old_employee , "29034093248");

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 400),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
    // setsearch(e);
  }

  const HandleRequestedemployee = (e) => {
    setdtPageindex(1);
    console.log(e, "saodipasid ");

    if (e != null) {
      setrequested(e);
      dispatch(setthe_requested_employee_list_filters(e))

      setrequested_emp({
        ...requested_emp,
        is_form_requested: e.value,
      });
    } else {
      setrequested({ value: "", label: "" });
      setrequested_emp({
        ...requested_emp,
        is_form_requested: "",
      });
      dispatch(setthe_requested_employee_list_filters({ value: "", label: "" }))

    }
  };


  const HandleOldemployee = (e) => {
    setdtPageindex(1);
    setOldEMp(e);
    dispatch(setthe_employeee_actions_forEmployee_filter(e))

    if (e != null) {
      setoldemp({
        ...oldemplo,
        old_employee: e.value,
      });
    }
  };

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const HandleSubmits = () => {

    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        page: dtpageindex,
        GetAPICALL: 2,
        Getapiall: {
          search: search,
          // page_size: dtpagesize,
          page_size: 20,
          page: dtpageindex,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
          client: Client,
          is_form_requested: requested_emp?.is_form_requested,

          old_employee: oldemplo.old_employee,
        }
      };
      setsearch("");
      dispatch(setUserDeleteActions(payload, setDeletePopup(false)));
    }
  };


  const HandleClientBranches = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      // dispatch(SetTheDashboardClientList(selectedVal));
      dispatch(setTheEmpoyeeAction_branch(selectedVal))
      setClients(selectedVal.value);
    } else if (selectedVal == null) {
      setClients("");

      dispatch(setTheEmpoyeeAction_branch({ value: "", label: "ALL" }))
      // dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
    }
  };


  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });



      setData({
        ...datas,
        region: selectedVal.value,
      });

      dispatch(settheEmployeeActionRegion(selectedVal));

      dispatch(settheEmployeeActionZone({ value: "", label: "ALL" }));

    }
    if (selectedVal == null) {
      setData({
        ...datas,
        region: "",
        zone: "",
      });



      setMuliselect3({ value: "", label: "ALL" });

      setMuliselect1({ value: "", label: "ALL" });
      dispatch(settheEmployeeActionRegion({ value: "", label: "ALL" }));

      dispatch(settheEmployeeActionZone({ value: "", label: "ALL" }));

    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...datas,
        zone: selectedVal.value,
      });

      dispatch(settheEmployeeActionZone(selectedVal));

    }
    if (selectedVal == null) {
      setData({
        ...datas,
        zone: "",
      });

      setMuliselect3({ value: "", label: "ALL" });
      dispatch(settheEmployeeActionZone({ value: "", label: "ALL" }));

    }
  };
  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);
    dispatch(setTheEmpoyeeAction_branch({ value: "", label: "ALL" }))

    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...datas,
        state: selectedVal.value,
        region: "",
        zone: "",
      });



      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      setClients("");

      dispatch(settheEmployeeActionState(selectedVal));
      dispatch(settheEmployeeActionRegion({ value: "", label: "ALL" }));

      dispatch(settheEmployeeActionZone({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...datas,
        state: "",
        zone: "",
        region: "",
      });
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      setClients("");

      dispatch(settheEmployeeActionState({ value: "", label: "ALL" }));
      dispatch(settheEmployeeActionRegion({ value: "", label: "ALL" }));

      dispatch(settheEmployeeActionZone({ value: "", label: "ALL" }));



    }
  };


  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
        });
        setSearch(SearchDebounance.Clientsearch)
      }
    },
    500,
    [SearchDebounance]
  );

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,

    });

  };

  ///---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };


  const handleNext = (next) => {

    setdtPageindex(next + 1);

  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);

    }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3 class="user-name mb-0">Employees </h3>
          </div>
        </div>
        <div

          className="row Filters"
          style={{
            padding: "15px 28px",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop: "0px "
          }}

        >
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect({ value: "", label: "All" });
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
            // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px", zIndex: 3 }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            // placeholder={
            //   datas.state == ""
            //     ? "without selected state you can't select Region"
            //     : "search"
            // }
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>

          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Client
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}

              onChange={(e) => {
                setdtPageindex(1);
                if (dtpageindex == 1) {
                  HandleClientBranches(e);
                  if (e != null) {
                  }
                }
              }}
              filterOption={() => true}

              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
              isClearable={true}
              value={state.EmployeeVerificationsNeed.EmployeeAction_Branch}
            />
          </div>
          {/* 
          <div
            className="col-3"
            style={{
              zIndex: "20",
              marginLeft: "-10px",
              display: "flex",
              flexDirection: "column",
              marginTop: "-22px",
            }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>

            </label>

            <div className="datepicker_dash">
              <DateRangePicker
                defaultValue={
                  state.EmployeeVerificationsNeed.EmployeeRangeOne == ""
                    ? []
                    : [
                        new Date(
                          state.EmployeeVerificationsNeed.EmployeeRangeOne
                        ),
                        new Date(
                          state.EmployeeVerificationsNeed.EmployeeRangeTwo
                        ),
                      ]
                }
                components={{
                  ClearButton: () => null,
                }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // onClean={(e) => cleaningrange(e)}

                onChange={(e) => {
                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    if (diffDays === 30) {
                      // Since we are using inclusive range, difference should be 30 for 31 days
                      setrange([]);
                      e.forEach((newValue) => {
                        const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                        const localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate(localISOTime);
                      });
                    } else if (diffDays < 30) {
                      setrange([]);
                      e.forEach((newValue) => {
                        const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                        const localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate(localISOTime);
                      });
                    } else {
                      toast.error("Please select a range of exactly 31 days.", {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    }
                  }
                }}
              />
            </div>
          </div> */}


        </div>

        <div className="employee-actions-table" style={{ padding: " 30px 40px", marginTop: "-13px" }}>
          {/* wide table: keep cells on one line and scroll horizontally (same as the Denave bulk upload table) */}
          <style>{`
            .employee-actions-table .table-responsive { overflow-x: auto; container-type: inline-size; }
            .employee-actions-table .INNERTABLE { width: max-content; min-width: 100%; }
            .employee-actions-table .Dusbinbacktabls { position: sticky; left: 0; width: 100cqw; }
            .employee-actions-table .table-responsive > .row { position: sticky; left: 0; width: 100cqw !important; }
            .employee-actions-table .TableDesgin { min-width: 100%; }
            .employee-actions-table .TableDesgin th {
              width: auto !important;
              white-space: nowrap;
              vertical-align: middle;
              padding: 12px 14px !important;
            }
            .employee-actions-table .TableDesgin td {
              white-space: nowrap;
              vertical-align: middle;
              padding: 12px 14px !important;
            }
            .employee-actions-table .TableDesgin td p { margin: 0; }
            .employee-actions-table .TableDesgin td .actions { flex-wrap: nowrap; }
          `}</style>
          <ReactTable
            data={state.ProfileSignatureCalls.ProfileSignatureDatas}
            columns={columns}
            totalItems={state.ProfileSignatureCalls.Total_count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            pageindex={pageindex}
            datacount={state.ProfileSignatureCalls.Total_count}
            OldEmployeFilters={true}
            oldemloyeeOptions={oldemloyeeOptions}
            OldEmp={OldEmp}
            Filter={true}
            HandleOldemployee={(e) => {
              HandleOldemployee(e);
            }}
            From_requested={true}
            form_requested_lists={form_requested_lists}
            HandleRequestedemployee_={(e) => {
              HandleRequestedemployee(e);
            }}
            requested_emp={requested}
            searchVal={TablePositionPersist?.EmployeeActions?.search == "" || TablePositionPersist?.EmployeeActions?.search == undefined ? "" : TablePositionPersist.EmployeeActions.search}
            search_key={true}


          />
        </div>
      </div>

      {rejoinEmployeeId && (
        <RejoinLinkPopup
          employeeId={rejoinEmployeeId}
          onClose={() => setRejoinEmployeeId(null)}
          onSent={rejoin.refresh}
        />
      )}
      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete the Employee"}

        />
      ) : null}
      {EditPopup && (
        <Employee_edit show={EditPopup} setshow={seteditpopup} employee={records}
          passingpayloads={{
            search: search,
            page_size: 20,
            page: dtpageindex,
            old_employee: oldemplo.old_employee,
            state: datas.state,
            region: datas.region,
            zone: datas.zone,
            client: Client
          }}

        />
      )}

      {exportpopup && (
        <Exportpopup
          setshow={setexportpopup}
          show={exportpopup}
          id={records}
          date_of_joining={date_of_joining}
        />
      )}


      {requestedpopup && (
        <RequestedPopup
          setshow={setrequestedpopup}
          show={requestedpopup}
          id={records}
          date_of_joining={date_of_joining}
          user_details={employee_det}
        />
      )}

    </>
  );
};

export default EmployeeActions;
